module.exports = __webpack_public_path__ + "static/media/spacecast.9449235e.mp4";